export default [
  {
    path: '/useful-knowledge/:key?',
    name: 'useful-knowledge',
    component: () => import('@/pages/UsefulKnowledge.vue'),
    meta: {},
  },
];
